import React from "react";

const CalendarColumn = ({ date, height }) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const isToday = new Date(date).toDateString() === today.toDateString();
  return (
    <div
      className={isToday ? "calendar-column today-column" : "calendar-column"}
      style={{ height: `${height}px` }}
    ></div>
  );
};

export default CalendarColumn;
